import React, { useCallback, useContext } from 'react';
import { action } from 'mobx';
import ReactResizeObserver from 'choerodon-ui/lib/_util/resizeObserver';
import { TableBoxSizing } from './enum';
import TableContext from './TableContext';
const TableSibling = function TableSibling(props) {
    const { position, boxSizing, children } = props;
    const { tableStore } = useContext(TableContext);
    const handleResize = useCallback(action((_, height) => {
        tableStore.siblingHeihgt = {
            ...tableStore.siblingHeihgt,
            [position]: height,
        };
    }), [tableStore, position]);
    if (boxSizing === TableBoxSizing.wrapper) {
        return (React.createElement(ReactResizeObserver, { resizeProp: "height", onResize: handleResize },
            React.createElement("div", { className: `${tableStore.prefixCls}-sibling` }, children)));
    }
    return (React.createElement(React.Fragment, null, children));
};
TableSibling.displayName = 'TableSibling';
export default TableSibling;
